import { call, put, takeLatest, all, fork, delay } from "redux-saga/effects";
import { APIClient } from "../../helpers/api_helper";
import { GET_CHANNEL_BY_ACTIVE, GET_CHANNEL_BY_ID } from "./actionType";
import {
  channelApiResponseSuccess,
  channelApiResponseError,
  channelUpdateLoading,
  channelResetError,
} from "./actions";

const api = new APIClient();

function* getChannelById({ payload: channelId }) {
  try {
    yield put(channelUpdateLoading(true));
    yield put(channelResetError());
    yield delay(300);

    const channel = (channelId) =>
      api.get(`${process.env.REACT_APP_API_BASE_URL}/channels/${channelId}`);
    const response = yield call(channel, [channelId]);

    if (response.token !== undefined) {
      sessionStorage.setItem("hxsmsToken", `${response.token}`);
      yield put(channelApiResponseSuccess(response));
    }
  } catch (error) {
    yield put(
      channelApiResponseError(
        "An error occurred while getting channel. Please try again later."
      )
    );
  } finally {
    yield put(channelUpdateLoading(false));
  }
}

function* getChannelByActive() {
  try {
    yield put(channelUpdateLoading(true));
    yield put(channelResetError());
    yield delay(300);

    const channel = () =>
      api.get(`${process.env.REACT_APP_API_BASE_URL}/channels/get-active`);
    const response = yield call(channel);

    if (response.token !== undefined) {
      sessionStorage.setItem("hxsmsToken", `${response.token}`);
      yield put(channelApiResponseSuccess(response));
    }
  } catch (error) {
    yield put(
      channelApiResponseError(
        "An error occurred while getting channel. Please try again later."
      )
    );
  } finally {
    yield put(channelUpdateLoading(false));
  }
}

export function* watchGetChannelById() {
  yield takeLatest(GET_CHANNEL_BY_ID, getChannelById);
}

export function* watchGetChannelByActive() {
  yield takeLatest(GET_CHANNEL_BY_ACTIVE, getChannelByActive);
}

function* ChannelSaga() {
  yield all([fork(watchGetChannelById), fork(watchGetChannelByActive)]);
}

export default ChannelSaga;
